import defaultReducer from "./defaultReducer";

const defaultState = {
  name: "",
  operator: 1000029,
  open: false,
  selectedProfile: { id: null, name: "" },
  ownershipTypeId: null,
  types: [],
  profiles: [],
  fields: [],
  changed: [],
  loading: true,
};

export default defaultReducer("ASSET_OWNERSHIP_PROFILE_MODAL", defaultState);
